import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify'; //? React-Toastify
import '../css/profile.css';
import { USER } from '../apollo/user/userQuery';
import { QUOTE_DELETE } from '../apollo/quote/quoteMutation';
import Spinners from './spinner/Spinners';

function Profile() {
  //! getting query
  const { userId } = useParams();

  const { loading, data } = useQuery(USER, {
    onError: (error) => {
      toast.error(error?.message);
    },
    variables: {
      userId: userId,
    },
  });

  //! delete mutations
  const [QuoteDelete] = useMutation(QUOTE_DELETE, {
    onError: (error) => {
      toast.error(error?.message);
    },
    onCompleted: ({ quoteDelete }) => {
      if (quoteDelete?.status === 200) {
        toast.success(quoteDelete?.message);
      }
    },
    refetchQueries: ['users', 'user'],
    // update(cache, { data }) {
    //   const deletedData = data?.quoteDelete?.payload?._id;

    //   const { user } = cache.readQuery({
    //     query: USER,
    //     variables: {
    //       userId: userId,
    //     },
    //   });

    //   if (deletedData) {
    //     cache.writeQuery({
    //       query: USER,
    //       user: {
    //         payload: {
    //           quotes: user?.payload?.quotes?.filter((item) => item._id !== deletedData),
    //         },
    //       },
    //     });
    //   }
    // },
  });

  if (loading) return <Spinners />;
  const Data = data?.user?.payload;
  //? #######################################################################
  return (
    <div className='profile mt-5'>
      <div className='container  my-5' style={{ backgroundColor: '#d63384' }}>
        {Data && (
          <div className='container rounded bg-white mt-5' key={Data?._id}>
            <div className='row'>
              <div className='col-md-4 border-right'>
                <div className='d-flex flex-column align-items-center text-center p-3 py-5 okay'>
                  <img
                    className='rounded-circle  avatar'
                    src={`https://robohash.org/${Data?.name}.png`}
                    width='200'
                    alt='user_profile'
                  />
                  <span className='font-weight-bold0 mt-3'>{Data?.email}</span>
                  <span className='font-weight-bold '>Name : {Data?.name}</span>
                  <span className='font-weight-bold'>Age : {Data.age}</span>
                </div>
              </div>
              <div className='col-md-8 my-2' style={{ backgroundColor: '#20c997' }}>
                <h2 className='text-center mt-2'>
                  <u>Your All Quotes</u>
                </h2>{' '}
                <br />
                {Data?.quotes?.length === 0 ? (
                  <h4 className='text-center'>You don't have any quotes</h4>
                ) : (
                  Data?.quotes?.map((el) => {
                    return (
                      <div className='card my-2' key={el?._id}>
                        <div className='card-body'>
                          <h5 className='card-title'>
                            {el?.quote}
                            <i
                              className='bi bi-trash float-end'
                              onClick={() => {
                                QuoteDelete({
                                  variables: {
                                    quoteId: el._id,
                                  },
                                });
                              }}
                            ></i>
                          </h5>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
